<template>
  <div class="edit">
    <el-form
      :model="editForm"
      ref="batchForm"
      :rules="editRules"
      label-width="160px"
      size="small"
      style="width: 100%; max-width: 600px"
    >
      <AccountingFeeFields v-model="editForm" />
      <el-form-item label="备注:" prop="remarks" label-width="88px">
        <el-input
          v-model="editForm.remarks"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          maxlength="500"
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { validateNumber } from "@/utils/index";
import AccountingFeeFields from "@/views/settlement-model/components/AccountingFeeFields.vue";
export default {
  components: { AccountingFeeFields },
  props: {
    currentData: {
      type: Object,
      default: () => ({}),
    },
    selectionData: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    currentData: {
      handler(newVal) {
                this.$set(this.editForm, "installFee", newVal.installFee == null ? 0 : Number(newVal.installFee));
        this.$set(this.editForm, "leakageDeduction", newVal.leakageDeduction == null ? 0 : Number(newVal.leakageDeduction));
        this.$set(this.editForm, "insuranceDeduction", newVal.insuranceDeduction == null ? 0 : Number(newVal.insuranceDeduction));
        this.$set(this.editForm, "regionalSubsidy", newVal.regionalSubsidy == null ? 0 : Number(newVal.regionalSubsidy));
        this.$set(this.editForm, "specialSubsidy", newVal.specialSubsidy == null ? 0 : Number(newVal.specialSubsidy));
        this.$set(this.editForm, "monthlySubsidy", newVal.monthlySubsidy == null ? 0 : Number(newVal.monthlySubsidy));
        this.editForm.remarks = newVal.remarks || "";
      },
      immediate: true,
    },
  },
  data() {
    return {
      editForm: {
        installFee: 0,
        leakageDeduction: 0,
        insuranceDeduction: 0,
        regionalSubsidy: 0,
        specialSubsidy: 0,
        monthlySubsidy: 0,

        remarks: "",
      },
      editRules: {
        installFee: [
          { required: true, message: "请输入安装费用", trigger: "blur" },
          { validator: validateNumber, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 提交表单
    editSubmit() {
      this.$refs.batchForm.validate((valid) => {
        if (valid) {
            this.axios({
            method: "post",
            url: `/pending-settlement-order/edit/${this.currentData.id}`,
            data: {
                id: this.currentData.id,
                installFee: this.editForm.installFee,leakageDeduction: this.editForm.leakageDeduction,insuranceDeduction: this.editForm.insuranceDeduction,regionalSubsidy: this.editForm.regionalSubsidy,specialSubsidy: this.editForm.specialSubsidy,monthlySubsidy: this.editForm.monthlySubsidy,
                settlementRemarks: this.editForm.remarks,
            },
          }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: "编辑成功",
                type: "success",
              });
             this.$emit("editSuccess");
            } else {
              this.$message({
                message: res.data.message,
                type: "error",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    bacthSubmit(){
      this.$refs.batchForm.validate((valid) => {
        if (valid) {
          const list = this.selectionData.map((item) => {
            return {
              id: item.id,
              installFee: this.editForm.installFee,leakageDeduction: this.editForm.leakageDeduction,insuranceDeduction: this.editForm.insuranceDeduction,regionalSubsidy: this.editForm.regionalSubsidy,specialSubsidy: this.editForm.specialSubsidy,monthlySubsidy: this.editForm.monthlySubsidy,
              settlementRemarks: this.editForm.remarks,
            };
          });
          this.axios({
            method: "post",
            url: `/pending-settlement-order/edit/batch`,
            data: list,
          }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: res.data.message,
                type: "success",
              });
              this.$emit("editSuccess");
            } else {
              this.$message({
                message: res.data.message,
                type: "error",
              });
            }
          });
        } else {
          return false;
        }
      });
    }
  },
};
</script>

<style scoped>
.edit {
  margin-top: 20px;
}
</style>
